import { clearRecoveryCredentials, parseRecoveryCallback, type RecoveryCallback } from "./recovery";

// Run before the auth client is imported: it otherwise consumes callbacks before
// the lazy reset page mounts. Keep credentials only in memory, never storage.
let incoming: RecoveryCallback | null = null;
if (window.location.pathname === "/admin/reset-password") {
  incoming = parseRecoveryCallback(window.location.href);
  if (incoming.kind !== "missing") clearRecoveryCredentials();
}

export const takeRecoveryCallback = (): RecoveryCallback => {
  const callback = incoming ?? parseRecoveryCallback(window.location.href);
  incoming = null;
  return callback;
};